import { Platform } from 'react-native'

import { Stack } from '@zet/design-system/layout'
import { B5, SH3 } from '@zet/design-system/typography'

type BenefitsType = {
  heading: string
  content: string[]
}

export const Benefits = ({ content, heading }: BenefitsType) => {
  return (
    <Stack
      className={
        Platform.OS === 'web'
          ? 'bg-neutral-white100 mb-2 px-3 py-3'
          : 'bg-neutral-white100 mb-2 px-3 py-[12]'
      }
    >
      <SH3 className="mb-2">{heading}</SH3>
      {content?.map((value, index) => (
        <Stack key={index}>
          <B5 className="text-grays-50 mt-1 text-justify"> {value}</B5>
        </Stack>
      ))}
    </Stack>
  )
}
